import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConfirmModel } from "../../Model/ConfirmModel";
import AddKnowledgeBaseModal from "../../Model/AddKnowledgeBaseModal";
import { setUnsavedChanges } from "../../Redux/Slice/Common/SelectedTabSlice";

export const KnowledgeBaseListSidebar = ({
  changeSelection,
  showSuccessMessage,
  selectedKnowledgeBase,
  getKnowledgeBaseData,
  searchText,
  setSearchText,
}) => {
  const dispatch = useDispatch();
  const hasUnsavedChanges = useSelector(
    (state) => state.hasUnsavedChanges.hasUnsavedChanges
  );
  const { knowledgeBaseListData } = useSelector(
    (state) => state?.knowledgeBaseList
  );

  const knowledgeBaseList =
    knowledgeBaseListData?.data && Array.isArray(knowledgeBaseListData?.data)
      ? knowledgeBaseListData?.data
      : [];
  const [showWarning, setWarning] = useState(false);
  const [editSelection, setEditSelection] = useState();
  const [showEditWarning, setEditWarning] = useState(false);
  const [isAddKnowledgeBaseModal, setIsAddKnowledgeBaseModal] = useState(false);

  const onAddConfirm = () => {
    setWarning(false);
    setIsAddKnowledgeBaseModal(true);
  };

  const onEditConfirm = () => {
    setEditWarning(false);
    dispatch(setUnsavedChanges(false));
    changeSelection(editSelection);
  };

  return (
    <div className="createAssistantMain__col h_100">
      {showWarning ? (
        <ConfirmModel
          onAccept={onAddConfirm}
          onReject={() => {
            setWarning(false);
          }}
          title="Add Knowledge Base!"
          message="Changes made will not be saved. Are you sure you wish to leave the page?"
        />
      ) : (
        ""
      )}
      {showEditWarning ? (
        <ConfirmModel
          onAccept={onEditConfirm}
          onReject={() => {
            setEditWarning(false);
          }}
          title="Edit Knowledge Base!"
          message="Changes made will not be saved. Are you sure you wish to leave the page?"
        />
      ) : (
        ""
      )}
      {isAddKnowledgeBaseModal ? (
        <AddKnowledgeBaseModal
          closePopup={() => setIsAddKnowledgeBaseModal(false)}
          onSuccess={() => {
            setIsAddKnowledgeBaseModal(false);
            showSuccessMessage("Knowledge Base added successfully!");
            getKnowledgeBaseData();
          }}
        />
      ) : (
        ""
      )}
      <div className="createAssistantMain__card h_100">
        <div className="btn__group btn__group--directionColumn h_100">
          <button
            className="btn btn__primary btn__outlined btn--full"
            onClick={() => {
              if (hasUnsavedChanges) {
                setWarning(true);
              } else {
                onAddConfirm();
              }
            }}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.00008 1.16699V12.8337M1.16675 7.00033H12.8334"
                stroke="#8b58f1"
                stroke-width="1.67"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Add Knowledge Base
          </button>
          <div className="formCol flexField w_100">
            <input
              className="form__input form__input--search form__input--sm"
              type="text"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value.trimStart());
              }}
              spellCheck="false"
              placeholder="Search a knowledge base"
            />
          </div>
          <div
            className="btn__group btn__group--directionColumn h_100 w_100"
            style={{
              overflowY: "auto",
              height: "100%",
              paddingRight: "0.5rem",
            }}
          >
            {knowledgeBaseList && knowledgeBaseList?.length ? (
              knowledgeBaseList.map((knowledgeBaseItem) => {
                return (
                  <button
                    className={
                      selectedKnowledgeBase?.id === knowledgeBaseItem?.id
                        ? "btn btn__primary btn--full"
                        : "btn btn__white btn--full"
                    }
                    style={{
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      textAlign: "start",
                    }}
                    onClick={() => {
                      if (hasUnsavedChanges) {
                        setEditSelection(knowledgeBaseItem);
                        setEditWarning(true);
                      } else {
                        changeSelection(knowledgeBaseItem);
                      }
                    }}
                  >
                    <div>{knowledgeBaseItem?.name}</div>
                  </button>
                );
              })
            ) : (
              <div className="no-data">No knowledge base found</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
